import { IPaymentsAction, IPaymentsContextState } from './payments-interfaces';
import { paymentsActionTypes } from './payments-action-types';

export const paymentsReducer = (state: IPaymentsContextState, action: IPaymentsAction): IPaymentsContextState => {
  switch (action.type) {
    case paymentsActionTypes.SET_UNPOSTED_BATCHES_DATA_LOADING: {
      return { ...state, isUnpostedBatchesDataLoading: action.payload };
    }
    case paymentsActionTypes.SET_BATCHES_DATA_LOADING: {
      return { ...state, isBatchesDataLoading: action.payload };
    }
    case paymentsActionTypes.SET_SHELVED_BATCHES_DATA_LOADING: {
      return { ...state, isShelvedBatchesDataLoading: action.payload };
    }
    case paymentsActionTypes.FETCH_UNPOSTED_BATCHES_DATA: {
      return {
        ...state,
        unpostedBatchesData: action.payload,
        isUnpostedBatchesDataLoading: false,
      };
    }
    case paymentsActionTypes.FETCH_BATCHES_DATA: {
      return {
        ...state,
        batchesData: action.payload,
        isBatchesDataLoading: false,
      };
    }
    case paymentsActionTypes.FETCH_SHELVED_BATCHES_DATA: {
      return {
        ...state,
        shelvedBatchesData: action.payload,
        isShelvedBatchesDataLoading: false,
      };
    }
    case paymentsActionTypes.SET_BATCHES_TO_DEFAULT: {
      return {
        ...state,
        unpostedBatchesData: [],
        isUnpostedBatchesDataLoading: true,
        batchesData: [],
        isBatchesDataLoading: true,
        shelvedBatchesData: [],
        isShelvedBatchesDataLoading: true,
      };
    }
    case paymentsActionTypes.START_PAYMENT_GATEWAY_DATA_LOADING: {
      return {
        ...state,
        isPaymentGatewayDataLoading: true
      };
    }
    case paymentsActionTypes.PAYMENT_GATEWAY_DATA: {
      return {
        ...state,
        paymentGatewayData: action.payload,
        isPaymentGatewayDataLoading: false
      };
    }
    case paymentsActionTypes.SET_PROVIDER_DATA_LOADING: {
      return { ...state, isProviderDataLoading: action.payload };
    }
    case paymentsActionTypes.FETCH_PROVIDER_DATA: {
      return {
        ...state,
        providerData: action.payload,
        isProviderDataLoading: false
      };
    }
    case paymentsActionTypes.SET_PAYMENT_GATEWAY_TYPE_LOADING: {
      return { ...state, isPaymentGatewayTypeLoading: action.payload };
    }
    case paymentsActionTypes.PAYMENT_GATEWAY_TYPE: {
      return {
        ...state,
        paymentGatewayType: action.payload,
        isPaymentGatewayTypeLoading: false,
      };
    }
    case paymentsActionTypes.PROVIDER_PAYMENT_TYPE: {
      return {
        ...state,
        providerPaymentType: action.payload
      };
    }
    case paymentsActionTypes.START_PAYMENT_REPORT_TYPES_LIST_LOADING: {
      return {
        ...state,
        isPaymentReportTypesListLoading: true,
      };
    }
    case paymentsActionTypes.FETCH_PAYMENT_REPORT_TYPES_LIST: {
      return {
        ...state,
        availablePaymentReportTypesList: action.payload,
        isPaymentReportTypesListLoading: false,
      };
    }
    case paymentsActionTypes.START_SET_PAYMENT_REPORT_LOADING: {
      return {
        ...state,
        isPaymentReportSending: true
      };
    }
    case paymentsActionTypes.END_SET_PAYMENT_REPORT_LOADING: {
      return {
        ...state,
        isPaymentReportSending: false
      };
    }
    case paymentsActionTypes.FETCH_DISPUTE_TYPES: {
      return {
        ...state,
        disputeTypes: action.payload
      };
    }
    case paymentsActionTypes.FETCH_PAYMENT_INSTRUMENT_DATA: {
      return {
        ...state,
        paymentInstrumentData: action.payload,
        paymentInstrumentDataLoading: false,
      };
    }
    case paymentsActionTypes.FETCH_PAYMENT_INSTRUMENT_DATA_LOADING: {
      return {
        ...state,
        paymentInstrumentDataLoading: action.payload
      };
    }
    case paymentsActionTypes.SET_EXPORT_CSV_LOADING: {
      return {
        ...state,
        isSettlementsExportLoading: action.payload,
        isExportTransactionCSVLoading: action.payload,
        isExportProviderCSVLoading: action.payload,
      };
    }
    case paymentsActionTypes.SET_DISPUTE_LOADING: {
      return { ...state, isAddingDisputeLoading: action.payload };
    }
    case paymentsActionTypes.SET_FETCH_PARTNER_BANK_LOADING: {
      return { ...state, isPartnerBankDetailsLoading: action.payload };
    }
    case paymentsActionTypes.SET_PROVIDERS_LIST_TO_DEFAULT: {
      return {
        ...state,
        providerData: [],
        isProviderDataLoading: true,
        isActive: '1',
        partnerId: '',
      };
    }

    case paymentsActionTypes.FETCH_PARTNER_BANK: {
      return {
        ...state,
        partnerBankDetails: action.payload,
        isPartnerBankDetailsLoading: false,
      };
    }
    case paymentsActionTypes.SET_UPDATING_FINANCIAL_ACCOUNT_LOADING: {
      return { ...state, isUpdatingFinancialAccountDataLoading: action.payload };
    }
    case paymentsActionTypes.FETCH_ENTITY_TYPES: {
      return { ...state, entityTypesList: action.payload };
    }
    case paymentsActionTypes.SET_PAYMENT_GATEWAY_REGISTER_LIST_LOADING: {
      return { ...state, isPaymentGatewayRegisterListLoading: action.payload };
    }
    case paymentsActionTypes.FETCH_PAYMENT_GATEWAY_REGISTER_LIST: {
      return { ...state, paymentGatewayRegisterList: action.payload, isPaymentGatewayRegisterListLoading: false };
    }
    case paymentsActionTypes.SET_PAYMENT_GATEWAY_LISTS_LOADING: {
      return { ...state, isProviderListsLoading: action.payload };
    }
    case paymentsActionTypes.FETCH_PAYMENT_GATEWAY_LISTS: {
      return { ...state, providerLists: action.payload, isProviderListsLoading: false };
    }
    case paymentsActionTypes.SET_NEW_PROVIDER_LOADING: {
      return { ...state, isAddingNewProviderLoading: action.payload };
    }
    case paymentsActionTypes.SET_PARTNER_BANK_VERIFICATION_LOADING: {
      return { ...state, isPartnerBankVerificationLoading: action.payload };
    }
    case paymentsActionTypes.FETCH_LOADING_FAIL: {
      return {
        ...state,
        isPaymentGatewayDataLoading: false,
        isProviderDataLoading: false,
        isPaymentReportSending: false,
        isPaymentReportTypesListLoading: false,
        isAddingDisputeLoading: false,
        isSettlementsExportLoading: false,
        isExportTransactionCSVLoading: false,
        isExportProviderCSVLoading: false,
      };
    }
  }
};
